import type { PlainSearchParameters } from 'algoliasearch-helper';
import type { CurrentRefinementsConnectorParamsRefinement } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';

import { getLocale, Locale } from '@libs/core';

export const localePrefix = {
    [Locale['en-US']]: 'US',
    [Locale['en-CA']]: 'CA',
};

const INDEX_NAME_PRODUCTS_US = 'p-US_products';
const INDEX_NAME_PRODUCTS_CA = 'p-CA_products';
const INDEX_LOCALE_PREFIX = localePrefix[getLocale()];

export const AlgoliaIndice = {
    PRODUCTS: `p-${INDEX_LOCALE_PREFIX}_products`,
    PRODUCTS_US: INDEX_NAME_PRODUCTS_US,
    PRODUCTS_CA: INDEX_NAME_PRODUCTS_CA,
    PRODUCTS_QUERY_SUGGESTIONS: `p-${INDEX_LOCALE_PREFIX}_products_query_suggestions`,
    PRODUCTS_HIGH_TO_LOW: `r-${INDEX_LOCALE_PREFIX}_products_price-high-to-low`,
    PRODUCTS_LOW_TO_HIGH: `r-${INDEX_LOCALE_PREFIX}_products_price-low-to-high`,
    PRODUCTS_BEST_SELLERS: `r-${INDEX_LOCALE_PREFIX}_products_best-sellers`,
    PRODUCTS_TOP_RATED: `r-${INDEX_LOCALE_PREFIX}_products_top-rated`,
    PRODUCTS_NEW_ARRIVALS: `r-${INDEX_LOCALE_PREFIX}_products_new-arrivals`,
    PRODUCTS_INVENTORIES: `p-inventories`,
    STORES: `p-stores`,
    // Todo: there no need for 2 banners indices to handle banners for US and CA
    // we should rename the index to p-banners
    BANNERS: `p-US_banners`,
    CATEGORIES: `p-${INDEX_LOCALE_PREFIX}_categories`,
    CATEGORIES_US: 'p-US_categories',
    CATEGORIES_CA: 'p-CA_categories',
};

export enum SortPrice {
    priceLowToHigh = 'price-low-to-high',
    priceHighToLow = 'price-high-to-low',
}

export type FilterType = {
    [key: string]: string;
};

export type FilterValueType = {
    label: string;
    value: number;
};

export type ItemFilterPropsType = {
    attribute: string;
    label: string;
    refine: (refinement: CurrentRefinementsConnectorParamsRefinement) => void;
    refinement: CurrentRefinementsConnectorParamsRefinement;
    value?: string | number;
};

export type ItemFilterType = {
    [key: string]: ItemFilterPropsType;
};

export type IAlgoliaRefinement = {
    attribute: string;
    urlName: string;
    isNumeric: boolean;
};

export type IAlgoliaRefinementList = {
    [key: string]: string | string[] | number | undefined;
};

export type IAlgoliaUIState = {
    refinementList: IAlgoliaRefinementList;
    query?: string;
    page?: string;
    sortBy?: string;
    toggle?: IAlgoliaRefinementList;
    numericMenu?: IAlgoliaRefinementList;
    range?: IAlgoliaRefinementList;
    configure: PlainSearchParameters;
};

export type IAlgoliaRouteState = {
    [key: string]: string | string[] | number;
};

export type IUiState = {
    [key: string]: IAlgoliaUIState;
};

export interface IVirtualSortProps {
    isSearchPage: boolean;
}
